import { Box, Stack, Typography } from '@mui/material';
import TelephoneInput from 'components/TelephoneInput';
import { AppRoutes } from 'enums/routes.enum';
import { useTranslation } from 'hooks/useTranslation';

export const PhoneSearchRepeater = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ position: 'relative', background: '#F6F8FC' }}>
            <Box
                sx={{
                    display: { xs: 'none', lmd: 'block' },
                    position: 'absolute',
                    left: 0,
                    width: '100%',
                    bottom: 0,
                    height: '50%',
                    background: '#12162B',
                    zIndex: 0,
                }}
            />
            <Stack
                sx={(theme) => ({
                    maxWidth: { xs: 'calc(100% - 40px)', lmd: '1200px' },
                    margin: { xs: '0 auto 40px', lmd: '0 auto' },
                    background: '#12162B',
                    borderRadius: '12px',
                    border: { xs: `1px solid ${theme.palette.text.lightGray}`, lmd: `2px solid ${theme.palette.text.lightGray}` },
                    padding: { xs: '50px 20px 40px', lmd: '34px 198px 49px' },
                    position: 'relative',
                    alignItems: 'center',
                })}
            >
                <Typography variant="h4" sx={{ fontSize: '38px', fontWeight: 700, lineHeight: '47.5px', mb: '20px', textAlign: 'center' }}>
                    {t('Find a Phone Location')}{' '}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            display: { xs: 'block', lmd: 'inline' },
                            background: 'linear-gradient(125deg, #0A2693 0%, #01CFFE 23.96%, #F2D3CD 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        {t('Right Now')}
                    </Typography>
                </Typography>
                <Typography variant="captionLight" sx={{ color: 'text.grey', fontSize: '20px', mb: '44px', textAlign: 'center' }}>
                    {t('TrackNumber label')}
                </Typography>
                <Stack
                    sx={{
                        alignSelf: 'stretch',
                        flexDirection: { xs: 'column', lmd: 'row' },
                        gap: '24px',
                        '& .MuiInputBase-root': {
                            borderRadius: '12px !important',
                        },
                        '& .MuiButtonBase-root': {
                            borderRadius: '12px',
                            height: '67px',
                        },
                        '& .MuiFormControl-root, & .MuiButtonBase-root': {
                            mt: '0 !important',
                        },
                        '& .MuiFormHelperText-root': {
                            position: 'absolute',
                            bottom: 0,
                            transform: 'translateY(155%)',
                        },
                    }}
                >
                    <TelephoneInput redirectPath={AppRoutes.SEARCH} disableClickEventSend />
                </Stack>
            </Stack>
        </Box>
    );
};
